var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03833 27.2147C8.16847 24.1029 11.6736 22.0811 16 22.0811C20.3264 22.0811 23.8315 24.1029 25.9617 27.2147M6.03833 27.2147C8.68748 29.5696 12.1767 31 16 31C19.8233 31 23.3125 29.5696 25.9617 27.2147M6.03833 27.2147C2.94734 24.4671 1 20.461 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 20.461 29.0527 24.4671 25.9617 27.2147M21.5263 12.8421C21.5263 15.8942 19.0521 18.3684 16 18.3684C12.9479 18.3684 10.4737 15.8942 10.4737 12.8421C10.4737 9.79001 12.9479 7.31579 16 7.31579C19.0521 7.31579 21.5263 9.79001 21.5263 12.8421Z",
    stroke: "#8E8E93",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.28d869b4cda001d1c7d5b03a61f78fc2.svg";
export { ForwardRef as ReactComponent };